import React from 'react'

export default function Privacypolicy() {
    return (
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Privacy Policy</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body fs-5">
                    <p><strong>Effective Date:</strong> 20th May 2024</p>

                    <p>CoverUP ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains what information we collect when you use our website (the "Website") and the Service, how we use that information, and your choices regarding your information.</p>

                    <h3>1. Information We Collect</h3>
                    <p>
                        <strong>1.1. </strong>We do not collect any personal information from you when you use the Service. This means we do not collect your name, email address, IP address, or any other information that could be used to identify you personally.
                    </p>
                    <p>
                        <strong>1.2. </strong>We may collect non-personal information, such as the type of browser you are using and the pages you visit on the Website. This information is used to improve the Service and understand how users interact with it.
                    </p>

                    <h3>2. Use of Information</h3>
                    <p>
                        <strong>2.1. </strong>We do not use any personal information for any purpose.
                    </p>
                    <p>
                        <strong>2.2. </strong>We may use non-personal information to:
                    </p>
                    <ul>
                        <li>Improve the Service.</li>
                        <li>Analyze how users interact with the Website.</li>
                        <li>Generate aggregate data reports.</li>
                    </ul>

                    <h3>3. Sharing of Information</h3>
                    <p>
                        <strong>3.1. </strong>We do not share any personal information with third parties.
                    </p>
                    <p>
                        <strong>3.2. </strong>We may share non-personal information with third-party service providers who help us operate the Website and Service. These service providers are contractually obligated to keep your information confidential.
                    </p>

                    <h3>4. Cookies</h3>
                    <p>
                        <strong>4.1. </strong>We do not use cookies on the Website.
                    </p>

                    <h3>5. Security</h3>
                    <p>
                        <strong>5.1. </strong>We take reasonable steps to protect the information you provide from loss, misuse, unauthorized access, disclosure, alteration, and destruction. However, no website or internet transmission is completely secure.
                    </p>

                    <h3>6. Children's Privacy</h3>
                    <p>
                        <strong>6.1. </strong>The Website and Service are not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and you believe your child has provided us with personal information, please contact us.
                    </p>

                    <h3>7. Changes to this Privacy Policy</h3>
                    <p>
                        <strong>7.1. </strong>We may update this Privacy Policy from time to time. We will post any changes on the Website. You are encouraged to review this Privacy Policy periodically for any updates.
                    </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Okay</button>
                </div>
            </div>
        </div>
    )
}
